import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from "./utils/router";

export const App = () => {
	useEffect(() => { document.title = 'Inevitable Cloud'; }, []);
  return <RouterProvider router={router} />;
};
